export const FaqsQuery = `
  query faqs (
    $first: Int,
    $where: FaqWhereUniqueInput!
  ) {
    values: faq(where: $where) {
      id
      __typename
      title
      slug
      heading
      accordions(first: $first) {
        __typename
        id
        heading
        content {
          html
        }
      }
    }
  }
`;
